/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DisablePhysicalStorePaymentForTheUserAccount200ResponseReissueOneOf
 */
export interface DisablePhysicalStorePaymentForTheUserAccount200ResponseReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseReissueOneOf
     */
    'cardType': DisablePhysicalStorePaymentForTheUserAccount200ResponseReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseReissueOneOf
     */
    'expiredDate': string;
}

export const DisablePhysicalStorePaymentForTheUserAccount200ResponseReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type DisablePhysicalStorePaymentForTheUserAccount200ResponseReissueOneOfCardTypeEnum = typeof DisablePhysicalStorePaymentForTheUserAccount200ResponseReissueOneOfCardTypeEnum[keyof typeof DisablePhysicalStorePaymentForTheUserAccount200ResponseReissueOneOfCardTypeEnum];


